import { useTranslation } from 'react-i18next';
import { WarningIcon } from 'cat-ecommerce-alloy';
import { ICON_WIDTH, WARNING_ICON_HEIGHT } from '../../../constants';
import styles from './WarningTextMessage.module.scss';

const WarningTextMessage = () => {
  const [t] = useTranslation();
  return (
    <div className="d-flex mt-1">
      <div>
        <WarningIcon
          width={ICON_WIDTH}
          height={WARNING_ICON_HEIGHT}
          className={`${styles['warning-message__icon']} u-fill-icon--MediumOrange`}
        />
      </div>
      <p className="u-fs--12 ps-2 u-color--DarkGray">
        {t('SHARE_CART_PII_MSG')}
      </p>
    </div>
  );
};
export default WarningTextMessage;
